"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVariantKeysList = void 0;
const attributesIgnoredForVariants_1 = require("../attributesIgnoredForVariants");
const generateVariantKeyByAttributes_1 = require("./generateVariantKeyByAttributes");
const generateVariantKeysList = (attributesObject, uniqueVariants = [], variantIndex = undefined) => {
    let result = [...uniqueVariants];
    const totalIndicies = Object.keys(attributesObject).length;
    const currentIndex = variantIndex === undefined ? totalIndicies - 1 : variantIndex;
    const nextIndex = currentIndex - 1;
    if (totalIndicies > 4)
        throw new Error(`You can't create more than 4 variants for product!`);
    if (currentIndex < totalIndicies) {
        const attributeKey = Object.keys(attributesObject)[currentIndex];
        const attributeValues = attributesObject[attributeKey];
        if ((attributeValues === null || attributeValues === void 0 ? void 0 : attributeValues.length) && !attributesIgnoredForVariants_1.attributesIgnoredForVariants.includes(attributeKey)) {
            result = [];
            for (const attributeValue of attributeValues) {
                if (uniqueVariants === null || uniqueVariants === void 0 ? void 0 : uniqueVariants.length) {
                    for (const existValue of uniqueVariants) {
                        const updatedValue = Object.assign(Object.assign({}, existValue), { attributes: [...existValue.attributes] });
                        updatedValue.attributes.push({ attribute: attributeKey, value: attributeValue });
                        const variantInfo = (0, generateVariantKeyByAttributes_1.generateVariantKeyByAttributes)(updatedValue.attributes);
                        updatedValue.key = variantInfo.key;
                        updatedValue.schema = variantInfo.schema;
                        result.push(updatedValue);
                    }
                }
                else {
                    const newVariantAttribute = { attribute: attributeKey, value: attributeValue };
                    const newVariantInfo = (0, generateVariantKeyByAttributes_1.generateVariantKeyByAttributes)([newVariantAttribute]);
                    result.push({ key: newVariantInfo.key, schema: newVariantInfo.schema, attributes: [newVariantAttribute] });
                }
            }
        }
    }
    if (nextIndex >= 0) {
        result = (0, exports.generateVariantKeysList)(attributesObject, result, nextIndex);
    }
    return result;
};
exports.generateVariantKeysList = generateVariantKeysList;
//# sourceMappingURL=generateVariantKeysList.js.map